export const selectTour = (state) => state.tour;
